'use client';

import { creationPreferenceStorage } from '@/lib/privacy/creation-preferences';

import { getAspectRatioOption } from '@/components/creation-workspace/placeholder-data';

const LAST_SELECTED_ASPECT_RATIO_STORAGE_KEY = 'popframe-last-selected-aspect-ratio';

export const getStoredLastSelectedAspectRatio = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const storedAspectRatio = creationPreferenceStorage.getItem(
      LAST_SELECTED_ASPECT_RATIO_STORAGE_KEY,
    );
    return getAspectRatioOption(storedAspectRatio)?.id ?? null;
  } catch {
    return null;
  }
};

export const persistLastSelectedAspectRatio = (aspectRatio: string): string | null => {
  const normalizedAspectRatio = getAspectRatioOption(aspectRatio)?.id ?? null;

  if (!normalizedAspectRatio || typeof window === 'undefined') {
    return normalizedAspectRatio;
  }

  try {
    creationPreferenceStorage.setItem(
      LAST_SELECTED_ASPECT_RATIO_STORAGE_KEY,
      normalizedAspectRatio,
    );
  } catch {
    return normalizedAspectRatio;
  }

  return normalizedAspectRatio;
};

export const clearStoredLastSelectedAspectRatio = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    creationPreferenceStorage.removeItem(LAST_SELECTED_ASPECT_RATIO_STORAGE_KEY);
  } catch {
    // Ignore storage failures so reset still completes.
  }
};
